import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

export default function LoadingPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed', // The element is positioned relative to the browser window
        top: '50%', // Move it down to 50% of the height
        left: '50%', // Move it right to 50% of the width
        transform: 'translate(-50%, -50%)', // This is to offset the spinner's own height and width
      }}
    >
      <CircularProgress />
    </Box>
  );
}